export interface AboutUsInterface {
  title: string;
  document: string;
  pdf: {
    cookies: string;
    endUser: string;
    izjava: string;
    politika: string;
    saglasnost: string;
    uslovi: string;
  };
}

export const AboutUsEN: AboutUsInterface = {
  title: "About Us",
  document: "Documents",
  pdf: {
    cookies: "Cookies",
    endUser: "Terms of Use",
    izjava: "Privacy Policy",
    politika: "Privacy Policy",
    saglasnost: "Consent for Data Processing",
    uslovi: "Terms of Use",
  },
};
